import { RenderResult } from '@dojo/framework/core/interfaces';
import { create, tsx } from '@dojo/framework/core/vdom';
import { ContentWrapper } from './ContentWrapper';
import { Text } from './Text';
import * as css from './IndustryExpertise.m.css';

const trailingTop = require('../assets/images/icon-illustration/profile.svg');
const leadingBottom = require('../assets/images/icon-illustration/non-profit.svg');
const trailingBottom = require('../assets/images/icon-illustration/medicine.svg');
const leadingMiddle = require('../assets/images/icon-illustration/finance.svg');
const leadingTop = require('../assets/images/icon-illustration/hospitality.svg');
const trailingMiddle = require('../assets/images/icon-illustration/prison.svg');

interface IndustryExpertiseProperties {
	icons?: {
		leadingTop: string;
		leadingMiddle: string;
		leadingBottom: string;
		trailingTop: string;
		trailingMiddle: string;
		trailingBottom: string;
	};
}

export interface IndustryExpertiseChildren {
	content?: RenderResult;
	title?: RenderResult;
}

const factory = create()
	.properties<IndustryExpertiseProperties>()
	.children<IndustryExpertiseChildren | undefined>();

export const IndustryExpertise = factory(function IndustryExpertise({ children, properties }) {
	const {
		icons = {
			trailingBottom,
			trailingMiddle,
			trailingTop,
			leadingBottom,
			leadingMiddle,
			leadingTop
		}
	} = properties();
	const defaultChildren = {
		title: 'Enterprise Industry Expertise',
		content: (
			<div classes={[css.content]}>
				<Text type="body">
					Among SitePen's greatest strengths is its wide-ranging experience across
					multiple industries. We have worked with some of the largest names in multiple
					markets with each engagement serving to refine our ability to address each
					enterprise's individual needs.
				</Text>
			</div>
		)
	};
	const [childProperties = defaultChildren] = children();
	const { title, content } = childProperties;

	return (
		<ContentWrapper>
			<section classes={[css.root, css.industry]}>
				<div classes={css.industryLeading}>
					<img
						src={icons.leadingTop}
						classes={[css.image, css.leadingTop]}
						alt=""
						loading="lazy"
						width={100}
						height={100}
					/>
					<img
						src={icons.leadingMiddle}
						classes={[css.image, css.industryMiddle]}
						alt=""
						loading="lazy"
						width={94}
						height={100}
					/>
					<img
						src={icons.leadingBottom}
						classes={[css.image, css.leadingBottom]}
						alt=""
						loading="lazy"
						width={100}
						height={100}
					/>
				</div>
				<div classes={css.contentWrapper}>
					<Text type="section">{title}</Text>
					{content}
				</div>
				<div classes={css.industryTrailing}>
					<img
						src={icons.trailingTop}
						classes={[css.image, css.trailingTop]}
						alt=""
						loading="lazy"
						width={98}
						height={100}
					/>
					<img
						src={icons.trailingMiddle}
						classes={[css.image, css.industryMiddle]}
						alt=""
						loading="lazy"
						width={100}
						height={100}
					/>
					<img
						src={icons.trailingBottom}
						classes={[css.image, css.trailingBottom]}
						alt=""
						loading="lazy"
						width={85}
						height={100}
					/>
				</div>
			</section>
		</ContentWrapper>
	);
});

export default IndustryExpertise;
